export default __webpack_public_path__ + "static/media/3D.f63c40ba.svg";